module.exports = __webpack_public_path__ + "static/img/book1.2b67338.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingDetail/book1.png
// module id = Lnxm
// module chunks = 0